import { useCallback } from 'react';
import { useLocale } from '@hooks/useLocale';
import { AddressField } from '@adapters/bigcommerce/types/address';
import useAddresses from './useAddresses';
import { HookError } from '../../errorHandlers';

export const deleteAddressFetcher = async (
  addressId: number,
  locale?: string
) => {
  if (!addressId) {
    throw new HookError('Address Id must be provided to update the address');
  }

  const deleteAddressResponse = await fetch(
    `/api/customer/deleteaddress?id=${addressId}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'accept-language': locale || '',
      },
    }
  );

  if (deleteAddressResponse.status !== 204) {
    throw new HookError('Delete address request failed');
  }

  return true;
};

const useDeleteAddress = () => {
  const { data = [], mutate } = useAddresses();
  const locale = useLocale();
  if (!locale) throw new HookError('Locale must be specified to login');

  return useCallback(
    async (addressId: number) => {
      const result = await deleteAddressFetcher(addressId, locale);

      if (result) {
        const newAddresses = data.filter(
          (currentAddress) => currentAddress[AddressField.id] !== addressId
        );
        mutate(newAddresses);
      }

      return result;
    },
    [locale, data, mutate]
  );
};

export default useDeleteAddress;
